// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-notification{box-sizing:border-box;position:absolute;top:64px;right:4px;max-width:384px;width:100%;z-index:3;transition:top .2s ease-in-out}.--mini .new-notification{top:48px}.new-notification .notifications-list__item{border-radius:8px;background:#2b3848;margin-top:10px}@media(max-width: 700px){.new-notification{top:44px;left:4px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
